module.exports = __webpack_public_path__ + "assets/pdf/E01-en-investigating-heatwaves.5a4d2488.pdf";